import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { saveAs } from 'file-saver';

import { HttpService } from 'src/app/services/http.service';
import { UntypedFormArray, UntypedFormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { SessionStorage } from 'src/app/services/session-storage.service';
import { NgClass, CurrencyPipe } from '@angular/common';
import { FontAwesomeModule, IconDefinition } from '@fortawesome/angular-fontawesome';
import { BasketComponent } from '../basket/basket.component';
import { PaymentComponent } from '../payment/payment.component';
import { TranslatePipe } from '@ngx-translate/core';
import { SafeHtmlPipe } from '../../pipe/safehtml.pipe';
import { TooltipDirective } from '../../directives/tooltip.directive';

import { JsonPipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';

@Component({
    templateUrl: './basket-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass, TooltipDirective, FontAwesomeModule, BasketComponent, PaymentComponent, CurrencyPipe, TranslatePipe, SafeHtmlPipe, JsonPipe]
})
export class BasketModalComponent implements OnInit, OnDestroy {
    @Input() brandId = '';
    @Input() venueId = '';
    @Input() promocode = '';
    @Input() message = false;
    @Input() sale : any;
    @Input() qty = 0;

        // Add these:
    @Input() fbad = '';
    @Input() gclid = '';
    @Input() gbraid = '';
    @Input() wbraid = ''
    @Input() bingad = '';
    @Input() affiliateId = '';
    @Input() adId = '';
    @Input() splitTest = '';
    @Input() test = '';

    @Input() set addToCart(datas: any[]) {
        if (!this.form) {
            this.pendingAdditions.unshift(...datas);
            return;
        }
        datas.slice().reverse().forEach(data => this.addVoucher(data, false));
        this.calculateTotal();
    }

    @Input() set setCart(vouchers: any[]) {
        if (!this.form) {
            this.pendingCart = vouchers;
            this.pendingAdditions = [];
            return;
        }
        this.replaceCart(vouchers);
    }

    public faChevronLeft: IconDefinition = faChevronLeft;
    public faChevronRight: IconDefinition = faChevronRight;

    public directories: any = JSON.parse(this.sessionStorage.getItem('directories'));
    public company: any = JSON.parse(this.sessionStorage.getItem('company'));
    public vouchersCopy: any[] = [];

    public form: UntypedFormArray;
    public lastVoucher: any;
    public payment = false;
    public totalVouchers = 0;
    public totalWrapping = 0;
    public totalDelivery = 0;
    public totalExtras = 0;
    public total = 0;
    public total_owed = 0;
    public sale_preloaded = false;

    public show_confirmation: boolean = false;

    private formChangeSub: Subscription;
    private pendingCart: any[] | undefined;
    private pendingAdditions: any[] = [];

    constructor(
        private http: HttpService,
        private builder: UntypedFormBuilder,
        private sessionStorage: SessionStorage,
        private toastr: ToastrService,
        private cd: ChangeDetectorRef
    ) { }

    ngOnInit() {

        if(this.sale && +this.sale.total_pending <= 0  && +this.sale.total_paid <= 0){
            //this.toPayment();
            this.sale_preloaded = true;
        }
        if(this.sale && +this.sale.total_pending + +this.sale.total_paid >= +this.sale.total_cost && +this.sale.total_cost >= 0){
            this.showConfirmation();
        }
        let vouchers = JSON.parse(this.sessionStorage.getItem('vouchers')) || [];
        try{
            vouchers = JSON.parse(localStorage.getItem('vouchers')) || vouchers;
        }catch{

        }

        this.form = this.builder.array([]);
        this.replaceCart([...this.pendingAdditions, ...(this.pendingCart ?? vouchers)]);
        this.pendingCart = undefined;
        this.pendingAdditions = [];
        this.formChangeSub = this.form.valueChanges.subscribe(this.calculateTotal.bind(this));

        if(this.promocode){
            this.toastr.info(`Promo code ${this.promocode} will be applied at checkout.`);
        }

        //if (this.message) this.lastVoucher = this.vouchers[0];
    }

    public cascadeChanges(): void {
        if (this.sale && this.sale?.vouchers){
            let cpt = 0;
            this.sale.vouchers.forEach(it=>{
                if(this.form && this.form.controls[cpt]){
                    this.form.controls[cpt].patchValue({voucher_id:it.voucher_id})
                }
                cpt++;
            })
            this.calculateTotal()
        }
    }

    ngOnDestroy() {
        if (this.formChangeSub) this.formChangeSub.unsubscribe();
    }

    public get header(): string {
        if ((+this.sale?.total_paid + +this.sale?.total_pending >= this.sale?.total_cost && this.sale?.total_cost >= 0) && !this.sale_preloaded && this.payment) return 'misc.sale_finalised';
        if (this.payment) return 'misc.payment';

        return 'misc.basket';
    }

    public close(): void {
        if (this.payment && !(+this.sale?.total_paid > 0 || +this.sale?.total_pending > 0)) this.payment = false;
        else document.querySelector('basket-modal').remove();
    }

    public toPayment(): void {
        this.payment = true;
        if(this.sale){
            delete this.sale.total_cost;
        } 
    }

    public setSale(sale: any): void {
        this.sale = sale;
        this.total_owed = +sale.total_cost - +sale.total_paid - +sale.total_pending;
        this.cascadeChanges();

        //console.log(sale.transactions, sale.transactions.length)

        if(!sale.payment_made || sale.transactions.length == 0) return;

        this.sessionStorage.removeItem('vouchers');
        try{
            localStorage.removeItem('vouchers');
        }catch{

        }
        this.sale_preloaded = false; //to show the confirmation screen
        this.showConfirmation();
    }

    public showConfirmation(): void{
        //fallback as it doesnt seem to work
        this.sale_preloaded = false; //to show the confirmation screen
        this.show_confirmation = true;
        this.payment = false;
    }

    private replaceCart(vouchers: any[]): void {
        this.form.clear({ emitEvent: false });
        vouchers.slice().reverse().forEach(item => this.addVoucher(item, false));
        this.calculateTotal();
    }

    public addVoucher(item: any, emitEvent = true): void {
        item = { ...item };
        //console.log('addVoucher', item);
        const disabled = !item.tag || item.tag === 'email';


        let fixed_image = false;

        let design = item?.image || item?.images || '';
        if(design){
            design = design.replace('/originals/','/600by450/');
        }

        if(item?.image) fixed_image = true;
        if(item?.images) fixed_image = true;
        if(item.fixed_image !== undefined){
            fixed_image = item.fixed_image;
        }

        if(item?.preset_id || item?.preset?.voucherpreset_id){
            let act_id = item?.preset?.activity_id ?? '0';
            let preset_id = item?.preset_id || item?.preset?.voucherpreset_id;

            if(preset_id.toString().indexOf('GP') == 0){
                //need to parse GV{preset_id}A{act_id}{currency}
                let matches  = /GP(\d+)A(\d+).*/.exec(preset_id);
                console.log(matches);
                preset_id = matches?.[1] || preset_id;

            }
            item.product_id = `GV${preset_id}A${act_id}${this.company?.currency || ''}`;
        }

        if(true || !design){
            let filteredImages = (this.company?.images||[]).filter(it=>it.caption==`wrap_option:${this.company.company_id}:email`)
            
            if(filteredImages.length == 0) filteredImages = this.company.images

            if(!design){
                design = item.design || this.company.image || filteredImages?.[0]?.full_url || '';
            }

            if (item.preset){
                design = item.preset?.image_url || '';
            } 
        }
            
        if(!this.sale){
            delete item.voucher_id
        }

        let title = item.title || '';
        if(item.preset && item.preset.name){
            title = item.preset.name;
        }

        //console.log(item);
        this.form.insert(0, this.builder.group({
            value: [{ value: item.value, disabled: true }],
            //value: [{ value: item.value, disabled: item?.preset?.voucherpreset_id ? true: false }],
            wrap_option_id: [item.wrap_option_id],
            mail_service_id: [item.mail_service_id],
            product_id: [item?.product_id || null],
            preset: [item.preset],
            name: [item.name],
            message: [item.message],
            title: [title],
            delivery_name: [{ value: item.delivery_name || '', disabled}],
            address_1: [{ value: item.address_1 || '', disabled }, Validators.required],
            address_2: [{ value: item.address_2 || '', disabled }],
            town: [{ value: item.town || '', disabled }, Validators.required],
            zip: [{ value: item.zip || '', disabled }, Validators.required],
            tag: [item.tag || 'email'],
            image: [design],
            design: [design],
            same_address: [false],
            fixed_image: [fixed_image],
            hideprice: [item?.hideprice || false],
            voucher_id: [item?.voucher_id || null],
            audio_video: [item.audio_video||''],
            record_audio: [item.record_audio|| null],
            change_act: [item.act_id||'']
        }), { emitEvent });

        //console.log(this.form.getRawValue());
    }

    public deleteVoucher(index: number): void {
        this.form.removeAt(index);

        window.dispatchEvent(new Event('voucherDeleted'));
    }

    public downloadVoucher(): void {
        this.http.getFile('/vouchers', {
            params: {
                _form: 'pdf',
                redemption_code: this.sale.vouchers?.[0].redemption_code,
                no_intercept_response: '1'
            },
            headers: {
                'X-API-KEY': this.sale.guest_key
            }
        }).pipe(
        ).subscribe(res => {
            saveAs(res.body, `${this.sale.vouchers?.[0].redemption_code}.pdf`);
        });
    }

    private calculateTotal(): void {
        const vouchers = this.form.getRawValue();

        this.totalVouchers = vouchers.reduce((acc, item) => acc + +item.value, 0);

        this.totalWrapping = vouchers.reduce((acc, item) => {
            const opt = this.directories.wrap_options.find(val => val.wrap_option_id === item.wrap_option_id);

            return acc + (opt ? +opt.price : 0);
        }, 0);

        this.totalDelivery = vouchers.reduce((acc, item) => {
            const opt = this.directories.mail_services.find(val => val.mail_service_id === item.mail_service_id);

            return acc + (opt ? +opt.price : 0);
        }, 0);

        this.totalExtras = vouchers.reduce((acc, item) => {
            return (item.audio_video || '') != '' ? acc + 1 : acc;
        }, 0);

        //console.log('total extras', this.totalExtras);
        this.total = this.totalVouchers + this.totalWrapping + this.totalDelivery;
        //+ this.totalExtras;

        this.sessionStorage.setItem('vouchers', JSON.stringify(vouchers));
        try{
            localStorage.setItem('vouchers', JSON.stringify(vouchers));
        }catch{

        }

        this.http.view_params.total = this.total;
        this.http.view_params.currency = this.company?.currency;
        this.http.view_params.product_ids = vouchers.map(it=>it.product_id);
        this.http.view_params.splitTest = this.splitTest;
        this.cd.markForCheck();
        setTimeout(()=>this.http.logWidgetView('modal'), 1000);
        window.dispatchEvent(new Event('vouchersUpdated'));
    }

    public get mode():string{
        return this.http.mode;
    }
}
